import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { findValidI18nKey, getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { BREEZE_INTELLIGENCE_CREDITS_100, BREEZE_INTELLIGENCE_CREDITS_1000, BREEZE_INTELLIGENCE_CREDITS_10000, BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED, BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED, BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED } from 'self-service-api/constants/ApiNames';
import BusinessObjectivesFeatures from './BusinessObjectivesFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SMALL = 'SMALL';
const MEDIUM = 'MEDIUM';
const LARGE = 'LARGE';
const getBreezePackSize = apiName => {
  switch (apiName) {
    case BREEZE_INTELLIGENCE_CREDITS_100:
    case BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED:
      return SMALL;
    case BREEZE_INTELLIGENCE_CREDITS_1000:
    case BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED:
      return MEDIUM;
    case BREEZE_INTELLIGENCE_CREDITS_10000:
    case BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED:
      return LARGE;
    default:
      return null;
  }
};
const allBusinessObjectives = [{
  shortName: 'credits',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'enrichment',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'formShortening',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'dataTest',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'buyerIntent',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'conversationalEnrichment',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'smartProperties',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'continuousDataEnrichment',
  packs: [MEDIUM, LARGE]
}, {
  shortName: 'jobChangeAlerts',
  packs: [MEDIUM, LARGE]
}, {
  shortName: 'outOfOfficeDetection',
  packs: [MEDIUM, LARGE]
}, {
  shortName: 'researchIntent',
  packs: [LARGE]
}];
const getFeatures = apiName => {
  const size = getBreezePackSize(apiName);
  if (!size) {
    return [];
  }
  return allBusinessObjectives.reduce((acc, businessObjective) => {
    const shortName = businessObjective.shortName;
    const nameKey = findValidI18nKey([`merchCards.breezeTile.businessObjectives.features.${shortName}.name.${size}`, `merchCards.breezeTile.businessObjectives.features.${shortName}.name`, `merchCards.breezeTile.businessObjectives.features.${shortName}.name.default`]);
    acc.push({
      shortName,
      description: getI18nText(`merchCards.breezeTile.businessObjectives.features.${shortName}.description`),
      displayName: nameKey ? getI18nText(nameKey) : '',
      isAvailable: businessObjective.packs.includes(size)
    });
    return acc;
  }, []);
};
const BreezeBusinessObjectives = ({
  apiName
}) => {
  const isMobile = useIsMobile();
  const features = getFeatures(apiName);
  if (isMobile) {
    // TODO - add skeleton loader when move breeze business obj to feature store
    return /*#__PURE__*/_jsx(AccordionItem, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.seeDetails"
      }),
      renderContent: () => /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "auto",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.breezeTile.businessObjectives.includes"
          })
        }), /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          features: features
        })]
      })
    }, apiName);
  }

  // TODO - add skeleton loader when move breeze business obj to feature store
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      "data-selenium-id": "biz-objectives-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `merchCards.breezeTile.businessObjectives.includes`
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      "data-selenium-id": "biz-objectives-2",
      children: /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
        features: features
      })
    })]
  });
};
export default BreezeBusinessObjectives;